/* eslint-disable */
// @ts-nocheck

// ─── CANOPUS COMMAND MOCK DATA ──────────────────────────────
// All data ported verbatim from Canopus_Command_Mockup.html.
// No refactoring — do not edit values here.

export const PHASES = [
  'Pre-Op Setup',
  'Time Out',
  'Incision',
  'Exposure',
  'Primary Procedure',
  'Hemostasis',
  'Closing',
  'Post-Op',
];

export const ST = {
  active: {
    l: 'In Progress',
    c: '#0FB7D1',
    bg: 'rgba(15,183,209,0.12)',
    bd: 'rgba(15,183,209,0.3)',
  },
  setup: { l: 'Pre-Op', c: '#FBBF24', bg: 'rgba(251,191,36,0.12)', bd: 'rgba(251,191,36,0.3)' },
  closing: {
    l: 'Closing',
    c: '#818CF8',
    bg: 'rgba(129,140,248,0.12)',
    bd: 'rgba(129,140,248,0.3)',
  },
  long: {
    l: 'Running Long',
    c: '#FFB300',
    bg: 'rgba(255,179,0,0.12)',
    bd: 'rgba(255,179,0,0.3)',
  },
  done: { l: 'Completed', c: '#34D399', bg: 'rgba(52,211,153,0.12)', bd: 'rgba(52,211,153,0.3)' },
  idle: { l: 'Idle', c: '#4B5563', bg: 'rgba(75,85,99,0.08)', bd: 'rgba(75,85,99,0.2)' },
  new: { l: 'Building Avg', c: '#6366F1', bg: 'rgba(99,102,241,0.12)', bd: 'rgba(99,102,241,0.3)' },
};

export const MONTHLY_TRENDS = [
  {
    month: 'Oct 2025',
    cases: 142,
    avgDur: 238,
    avgVariance: 26.4,
    coverage: 48,
    avgPhaseGap: 3.8,
    longRate: 28,
    siTotal: 3408,
    siOffCase: 264,
    siPerCase: 24.0,
    avgTfi: 58,
  },
  {
    month: 'Nov 2025',
    cases: 168,
    avgDur: 231,
    avgVariance: 24.1,
    coverage: 55,
    avgPhaseGap: 3.5,
    longRate: 26,
    siTotal: 4200,
    siOffCase: 340,
    siPerCase: 25.0,
    avgTfi: 62,
  },
  {
    month: 'Dec 2025',
    cases: 155,
    avgDur: 226,
    avgVariance: 22.8,
    coverage: 58,
    avgPhaseGap: 3.3,
    longRate: 25,
    siTotal: 4030,
    siOffCase: 382,
    siPerCase: 26.0,
    avgTfi: 67,
  },
  {
    month: 'Jan 2026',
    cases: 198,
    avgDur: 222,
    avgVariance: 20.5,
    coverage: 64,
    avgPhaseGap: 3.0,
    longRate: 23,
    siTotal: 5346,
    siOffCase: 520,
    siPerCase: 27.0,
    avgTfi: 71,
  },
  {
    month: 'Feb 2026',
    cases: 215,
    avgDur: 218,
    avgVariance: 18.7,
    coverage: 71,
    avgPhaseGap: 2.7,
    longRate: 21,
    siTotal: 5913,
    siOffCase: 628,
    siPerCase: 27.5,
    avgTfi: 74,
  },
  {
    month: 'Mar 2026',
    cases: 232,
    avgDur: 215,
    avgVariance: 17.2,
    coverage: 76,
    avgPhaseGap: 2.5,
    longRate: 19,
    siTotal: 6496,
    siOffCase: 742,
    siPerCase: 28.0,
    avgTfi: 76,
  },
  {
    month: 'Apr 2026',
    cases: 52,
    avgDur: 212,
    avgVariance: 16.1,
    coverage: 78,
    avgPhaseGap: 2.3,
    longRate: 18,
    siTotal: 1456,
    siOffCase: 186,
    siPerCase: 28.0,
    avgTfi: 76,
  },
];

export const SPECIALTY_VARIANCE = [
  { specialty: 'Spine', baseline: 28.2, current: 17.8, reduction: 36.9, cases: 148 },
  { specialty: 'Orthopedics', baseline: 22.5, current: 14.2, reduction: 36.9, cases: 96 },
  { specialty: 'Neurosurgery', baseline: 30.1, current: 21.4, reduction: 28.9, cases: 44 },
];

export const SURGEON_VARIANCE = [
  {
    surgeon: 'Dr. Masson',
    procedure: 'Lumbar Micro',
    baselineVar: 24.5,
    currentVar: 16.8,
    reduction: 31.4,
    baselineCases: 15,
    totalCases: 47,
    trend: 'improving',
  },
  {
    surgeon: 'Dr. Patel',
    procedure: 'ALIF L4-L5',
    baselineVar: 28.1,
    currentVar: 20.2,
    reduction: 28.1,
    baselineCases: 15,
    totalCases: 32,
    trend: 'improving',
  },
  {
    surgeon: 'Dr. Chen',
    procedure: 'Cerv Laminoplasty',
    baselineVar: 22.8,
    currentVar: 14.5,
    reduction: 36.4,
    baselineCases: 15,
    totalCases: 28,
    trend: 'improving',
  },
  {
    surgeon: 'Dr. Kim',
    procedure: 'TKA',
    baselineVar: 20.3,
    currentVar: 13.8,
    reduction: 32.0,
    baselineCases: 15,
    totalCases: 35,
    trend: 'stable',
  },
  {
    surgeon: 'Dr. Rivera',
    procedure: 'Craniotomy',
    baselineVar: 32.5,
    currentVar: 22.0,
    reduction: 32.3,
    baselineCases: 15,
    totalCases: 22,
    trend: 'improving',
  },
  {
    surgeon: 'Dr. Thompson',
    procedure: 'Rotator Cuff',
    baselineVar: 18.2,
    currentVar: 12.5,
    reduction: 31.3,
    baselineCases: 15,
    totalCases: 41,
    trend: 'stable',
  },
  {
    surgeon: 'Dr. Okafor',
    procedure: 'Post. Spinal Fusion',
    baselineVar: null,
    currentVar: 28.0,
    reduction: null,
    baselineCases: 6,
    totalCases: 6,
    trend: 'building',
  },
  {
    surgeon: 'Dr. Nguyen',
    procedure: 'ACL Reconstruction',
    baselineVar: 16.8,
    currentVar: 10.5,
    reduction: 37.5,
    baselineCases: 15,
    totalCases: 19,
    trend: 'improving',
  },
];

export const HEATMAP_DATA = [
  { day: 'Mon', OR1: 18, OR2: 22, OR3: 14, OR4: 25, OR5: 20, OR6: 15, OR7: 12, OR8: 16 },
  { day: 'Tue', OR1: 16, OR2: 19, OR3: 16, OR4: 28, OR5: 18, OR6: 13, OR7: 14, OR8: 18 },
  { day: 'Wed', OR1: 20, OR2: 24, OR3: 12, OR4: 22, OR5: 22, OR6: 16, OR7: 11, OR8: 15 },
  { day: 'Thu', OR1: 15, OR2: 20, OR3: 18, OR4: 30, OR5: 19, OR6: 14, OR7: 13, OR8: 20 },
  { day: 'Fri', OR1: 22, OR2: 26, OR3: 20, OR4: 32, OR5: 24, OR6: 18, OR7: 16, OR8: 22 },
];

export interface TabDef {
  id: string;
  label: string;
  live?: boolean;
  beta?: boolean;
}

export const TABS: TabDef[] = [
  { id: 'or', label: 'OR Overview', live: true },
  { id: 'staff', label: 'Staff', live: true },
  { id: 'si', label: 'Surgical Inquiries', beta: true },
  { id: 'historical', label: 'Historical Cases', beta: true },
  { id: 'performance', label: 'Performance', beta: true },
  { id: 'trends', label: 'Trends', beta: true },
];
